/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import Modal from '@hig/modal';
import ProgressBar from '@hig/progress-bar';
import Typography from '@hig/typography';
import './modalProgress.css';
import merge from 'lodash.merge';
import Button from '@hig/button';

export class ModalDownloadProgress extends Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.url && this.props.url) {
            this.autoDownload(this.props.url);
        }
    }

    autoDownload(url) {
        if (!url) return;

        try {
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (e) {
            window.location.href = url;
        }
    }

    render() {
        const modalStyles = /* istanbul ignore next */ (styles) =>
            merge(styles, {
                modal: {
                    window: {
                        width: '371px',
                        height: 'auto'
                    }
                }
            });

        const done = this.props.url != null;
        const title = this.props.title;

        const iconAsBackgroundImage = {
            width: '48px',
            height: '48px',
            backgroundImage: 'url(' + this.props.icon + ')'
        };

        return (
            <Modal
                open={this.props.open}
                title={title}
                onCloseClick={this.props.onClose}
                percentComplete={null}
                stylesheet={modalStyles}
                headerChildren={
                    <header id="customHeader">
                        <div className="customHeaderContent">
                            <div className="title">
                                <Typography
                                    style={{
                                        paddingLeft: '8px',
                                        fontSize: 'inherit',
                                        fontWeight: 'inherit',
                                        lineHeight: 'inherit',
                                        color: 'inherit'
                                    }}
                                >
                                    {title}
                                </Typography>
                            </div>
                        </div>
                    </header>
                }
            >
                <div className="modalBody">
                    <div className="modalContent">
                        <div style={iconAsBackgroundImage} />
                        <div className="modalAction" fontWeight="bold">
                            <Typography>
                                {this.props.label ? this.props.label : 'Missing label.'}
                            </Typography>
                            {!done && <ProgressBar className="modalProgress" />}
                        </div>
                    </div>

                    {done && (
                        <div id="modalDone">
                            <Button
                                className="orangeButton modalOkButton"
                                style={{
                                    width: '116px',
                                    height: '36px',
                                    borderRadius: '2px',
                                    marginLeft: '12px'
                                }}
                                size="small"
                                title="Ok"
                                onClick={this.props.onClose}
                            />
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

/* istanbul ignore next */
export default ModalDownloadProgress;